<script>
    import List, { Item, Text } from "@smui/list";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import loading from "../../components/loading";

    import title from "../../components/title";
    import { post } from "../../http";
    import { setObject } from "../../session";

    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    export let location;
    let times = [];

    function select(time) {
        setObject("pickup", { pickup_time: time });
        navigate("/pickup/origin");
    }

    onMount(() => {
        title.set("Waktu Pickup");
        sessionStorage.removeItem("hasRequest");
        loading.show();
        post("/api/pickup_time")
            .then((resp) => {
                if (resp.status == 0) times = resp.data;
            })
            .finally(() => loading.hide());
    });
</script>

<style lang="scss">
    .list {
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }
</style>

<div class="content">
    <div class="caption">Pilih waktu pickup</div>

    <div class="list">
        <List>
            <!-- <Item on:SMUI:action={() => clickedGroup = 'Bruce Willis'}> -->
            {#each times as time}
                <Item on:SMUI:action={() => select(time)}>
                    <Text>{time}</Text>
                </Item>
            {/each}
        </List>
    </div>
</div>
